import {User} from '../../util/fetch-wakanda';

/** AUDIKA */
export const AU02_GROUP_ID = 'BC2A391373EA974A8C23ED44B90BAC0B';

export const AU05_GROUP_ID = '0367B1F6960DA34AA05BDAFCE10F0D4D';

/** Returns whether an user is from AUDIKA */
export const userIsAudika = (user: User): boolean =>
  user.groupID === AU02_GROUP_ID;
